<template>
  <div class="aha-tabs">
    <!-- Tab navigation -->
    <div class="aha-tab-list-wrp">
      <ul class="aha-tab-list">
        <li
          v-for="tab in tabs"
          :key="tab.title"
          class="aha-tab-title"
          :data-text="tab.title"
          :class="{ active: tab.active }"
          @click="openTab($event, tab)"
        >
          <span class="aha-tab-title__text">{{ tab.title }}</span>
          <span v-if="tab && tab.postTitleComponent" class="aha-tab-title__suffix">
            <component :is="tab.postTitleComponent" />
          </span>
        </li>
      </ul>
    </div>

    <!-- Tab content -->
    <div class="aha-tab-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    activeIndex: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      tabs: [],
      activeTab: null,
    }
  },
  watch: {
    activeIndex(newIndex) {
      this.openTab(null, this.tabs[+newIndex])
    },
  },
  mounted() {
    if (!this.tabs.length) {
      throw new Error('tab-list used without tab-item')
    }

    const activeTab = this.tabs[this.activeIndex] || this.tabs[0]
    activeTab.open()

    this.activeTab = activeTab
  },
  methods: {
    addTab(tab) {
      this.tabs.push(tab)
    },
    openTab(e, tab) {
      if (tab.disabled) {
        return
      }

      this.activeTab.close()
      tab.open()

      const index = this.tabs.indexOf(tab)

      this.$emit('change', e, tab, index)
      this.$emit('update:activeIndex', index)

      this.activeTab = tab
    },
  },
}
</script>

<style lang="scss" scoped>
  .aha-tabs {
    @apply flex;
  }
  .aha-tab-list {
    min-width: 12rem;
  }
  .aha-tab-title {
    @apply py-4 cursor-pointer inline-block mr-5 font-bold;
    -webkit-tap-highlight-color:  rgba(255, 255, 255, 0);

    &:hover {
      @apply text-primary-90 transition-colors;
    }
  }
  .aha-tab-title.active {
    @apply border-b-2 border-primary-90;
    .aha-tab-title__text {
      @apply text-primary-90;
    }
  }
</style>
